
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icon/Controls/First Page","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Masked Area","transform":"translate(-2081 -1782)","d":"M0 0h24v24H0z","stroke":"#707070","fill":"#18181a"}})])]),_c('g',{attrs:{"data-name":"Icon/Controls/First Page","transform":"translate(2081 1782)","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 664","d":"M-2062.59-1765.41l-4.59-4.59 4.59-4.59-1.41-1.41-6 6 6 6zM-2075-1776h2v12h-2z","fill":"#18181a"}})])])
          )
        }
      }
    